import { useState } from "react";
import { Smartphone, X } from "lucide-react";
import PwaInstallModal from "./PwaInstallModal";

// Guest Mode — contextual, dismissible, NEVER blocking install nudge. Only rendered
// once a guest has actually engaged (Workspace.jsx gates `show` on 5 scrolled cards
// or 1 completed Check), so it never interrupts a first-time visitor's browsing.
export default function PwaNudgeBanner({ show, onDismiss }) {
  const [detailsOpen, setDetailsOpen] = useState(false);
  if (!show) return null;
  return (
    <>
      <div
        data-testid="pwa-nudge-banner"
        className="fixed inset-x-3 bottom-[76px] z-30 flex items-center gap-3 rounded-2xl border border-brand-orange/30 bg-white p-3 shadow-xl dark:border-white/10 dark:bg-[#1a1a1d] md:inset-x-auto md:bottom-6 md:right-6 md:max-w-sm"
      >
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-brand-orange/10"><Smartphone className="h-5 w-5 text-brand-orange" /></div>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-black text-slate-900 dark:text-white">Add Snaggedify to your Home Screen</p>
          <button onClick={() => setDetailsOpen(true)} data-testid="pwa-nudge-see-how-btn" className="text-[11px] font-bold text-brand-orange underline underline-offset-2">See how</button>
        </div>
        <button onClick={onDismiss} data-testid="pwa-nudge-dismiss-btn" aria-label="Dismiss" className="shrink-0 text-slate-400 hover:text-slate-700 dark:hover:text-white">
          <X className="h-4 w-4" />
        </button>
      </div>
      <PwaInstallModal open={detailsOpen} onClose={() => setDetailsOpen(false)} />
    </>
  );
}
